import { Question } from "./Question";

export const inspectionSeverityOptions = {
  info: "Info",
  warning: "Waarschuwing",
  critical: "Kritiek",
  lsr_violation: "LSR-overtreding",
};
export type InspectionSeverity = keyof typeof inspectionSeverityOptions;

export class InspectionComment {
  constructor(
    public readonly user: string,
    public readonly comment: string,
    public readonly updatedAt: Date | null,
    public readonly isFixedWithin24Hours: boolean,
    public readonly isFixedAt: Date | null,
  ) {}

  static fromJson(json: any): InspectionComment {
    return new InspectionComment(
      json["user"],
      json["comment"],
      json["updated_at"] ? new Date(json["updated_at"]) : null,
      json["is_fixed_within_24_hours"],
      json["is_fixed_at"] ? new Date(json["is_fixed_at"]) : null,
    );
  }
}

export class InspectionFinding {
  constructor(
    public readonly id: string,
    public readonly inspectionId: string,
    public readonly inspectionQuestionId: string,
    public readonly description: string,
    public readonly severity: InspectionSeverity,
    public readonly comments: InspectionComment[],
    public readonly canStillBeFixed: boolean,
    public readonly question: Question | null,
  ) {}

  static fromJson(json: any): InspectionFinding {
    return new InspectionFinding(
      json["id"],
      json["inspection_id"],
      json["inspection_question_id"],
      json["description"],
      json["severity"],
      json["comments"] ? json["comments"].map(InspectionComment.fromJson) : null,
      json["can_still_be_fixed"],
      json["question"] ? Question.fromJson(json["question"]) : null,
    );
  }
}
